<template>
  <div class="w100 pb20 pl20 pr20" v-loading="loading">
    <div class="w100 flex-box al-b">
      <Sift class="flex-1" ref="needSift" :sift-data="siftData" v-if="siftData.length" @change="initPage">
        <el-col :span="6">
          <el-button class="ml10 mb10" type="primary" @click="initPage">搜索</el-button>
        </el-col>
      </Sift>
    </div>

    <el-table class="w100 mt10 table" header-row-class-name="table-head" stripe :data="list">
      <el-table-column align="center" label="序号" width="60px">
        <template slot-scope="scope">
          {{ pageNum * pageSize - pageSize + scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column align="center" v-for="(item, index) in labelData" :key="index" :label="item.label">
        <template slot-scope="scope">
          <span v-if="item.type == 'date'">{{ scope.row[item.key] | filterDate(item.dateType) }}</span>
          <p v-else>{{ scope.row[item.key] }}</p>
        </template>
      </el-table-column>
    </el-table>

    <div class="mt20 flex-box">
      <div class="flex-1"></div>
      <el-pagination background @size-change="changeSize" @current-change="changePage" :current-page="pageNum" :page-sizes="[10, 20, 30, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
    </div>
  </div>
</template>

<script>
import Sift from "@/components/sift/Sift";

export default {
  name: "CommonSearch",
  components: {
    Sift
  },
  props: ["serve-id"],
  data() {
    return {
      baseUrl: process.env.BASE_URL,

      loading: false,
      siftData: [],
      labelData: [],
      list: [],
      pageNum: 1,
      pageSize: 20,
      total: 0
    };
  },
  computed: {},
  created() {
    this.fetchSiftData();
  },
  mounted() {},
  destroyed() {},
  methods: {
    fetchSiftData() {
      this.loading = true;
      this.$http
        .post(
          "/queryTemplate/getTitleData",
          this.$qs.stringify({
            serveId: this.serveId
          })
        )
        .then(({ data }) => {
          if (data.resCode == 0) {
            this.siftData = data.resData.siftData;
            this.labelData = data.resData.labelData;
            this.$nextTick(() => {
              this.initPage();
            });
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    fetchList() {
      let obj = {};
      if (this.siftData.length > 0) {
        obj = this.$refs.needSift.getValue();
      }
      obj.pageNum = this.pageNum;
      obj.pageSize = this.pageSize;
      obj.serveId = this.serveId;
      this.loading = true;

      this.$http
        .get("/queryTemplate/pageList", {
          params: obj
        })
        .then(({ data }) => {
          if (data.resCode == 0) {
            this.list = data.resData.list;
            this.total = data.resData.total;
          }
          this.loading = false;
        })
        .catch(err => {
          this.loading = false;
        });
    },
    initPage() {
      this.pageNum = 1;
      this.fetchList();
    },
    changeSize(value) {
      this.pageSize = value;
      this.fetchList();
    },
    changePage(value) {
      this.pageNum = value;
      this.fetchList();
    }
  },
  watch: {},
  filters: {}
};
</script>

<style scoped>
</style>
